import { faShareAlt } from '@fortawesome/free-solid-svg-icons'
import dynamic from 'next/dynamic'
import { useState } from 'react'

import type { MoreAuthorToolsProps } from '../foldout-author-menus/more-author-tools'
import { UserToolsItem } from '../user-tools-item'
import type { ShareModalProps } from '@/components/user-tools/share/share-modal'
import { useInstanceData } from '@/contexts/instance-context'
import { UuidType } from '@/data-types'

const ShareModal = dynamic<ShareModalProps>(
  () =>
    import('@/components/user-tools/share/share-modal').then(
      (mod) => mod.ShareModal
    ),
  { ssr: false }
)

export function Share({ data, aboveContent }: MoreAuthorToolsProps) {
  const { lang, strings } = useInstanceData()
  const [shareOpen, setShareOpen] = useState(false)

  const showPdf =
    data &&
    [
      UuidType.Page,
      UuidType.Article,
      UuidType.Course,
      UuidType.ExerciseGroup,
      UuidType.Exercise,
    ].includes(data.typename as UuidType)

  const showCopyContent =
    lang === 'de' &&
    data &&
    [UuidType.Article, UuidType.ExerciseGroup, UuidType.Exercise].includes(
      data.typename as UuidType
    )

  return (
    <>
      <UserToolsItem
        title={strings.share.button}
        onClick={() => setShareOpen(true)}
        aboveContent={aboveContent}
        icon={faShareAlt}
      />
      {shareOpen ? (
        <ShareModal
          isOpen={shareOpen}
          setIsOpen={setShareOpen}
          showCopyContent={showCopyContent}
          showPdf={showPdf}
        />
      ) : null}
    </>
  )
}
